<template>
  <div
    :style="{
      top: $route.name == 'store' ? '80px' : '20px',
      position: $route.name == 'store' ? 'sticky' : 'unset',
    }"
  >
    <div class="bg-white">
      <div v-if="giftCartItems.length > 0" class="cart-items-wrapper">
        <div class="container">
          <template v-for="(item, index) in giftCartItems">
            <cart-item :cart-item="item" :key="index" />
          </template>
        </div>
      </div>
      <hr v-if="giftCartItems.length > 0" />
      <div class="container">
        <div class="row">
          <div class="col-sm-12 cart-totals">
            <div class="cart-subtotal-label">
              {{ $t("message.subtotal") }}
              <small class="fw-600"
                >({{ cartLength }} {{ $t("message.items") }})</small
              >
            </div>
            <div class="cart-subtotal-cost">
              {{ giftCartValue | formatMoney(currencySign) }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 cart-totals">
            <div class="cart-subtotal-label">{{ $t("message.surcharge") }}</div>
            <div class="cart-subtotal-cost">
              {{ getGiftSurchargeAmount | formatMoney(currencySign) }}
            </div>
          </div>
        </div>
        <div
          v-show="
            giftCartItems.length > 0 &&
            giftCartValue > 0 &&
            $route.name == 'giftcardCheckout'
          "
          class="row"
        >
          <CouponComponent
            ref="couponComponent"
            :className="'cart-totals'"
          ></CouponComponent>
        </div>
      </div>
      <hr />
      <div class="container">
        <div class="row">
          <div class="col-sm-12 cart-totals">
            <div class="total">{{ $t("message.total") }}</div>
            <div class="cost">
              {{ giftTotalPrice | formatMoney(currencySign) }}
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-sm-12 checkout">
            <button
              v-if="orderMode"
              :disabled="orderDisbaled"
              type="submit"
              class="btn btn-primary btn-lg btn-block shadow mb-2 d-flex justify-content-center align-items-center"
            >
              {{ $t("message.placeOrder") }}
              <span v-show="proccessing">
                <i class="spin ml-4" />
              </span>
            </button>
            <router-link
              v-else
              :to="{
                name: 'giftcardCheckout',
                params: {
                  storeid: $route.params.storeid,
                  storename: $route.params.storename,
                },
              }"
              :class="{
                disabled: giftCartItems.length === 0 ? 'disabled' : '',
              }"
              class="btn btn-primary btn-lg btn-block shadow mb-2"
            >
              {{
                storeClosed ? $t("message.storeClosed") : $t("message.checkout")
              }}
            </router-link>
            <div
              v-show="!exceedMinPurchase && !storeClosed"
              class="color-red pt-1 text-center"
            >
              {{ $t("message.minimumPurchaseIs") }}
              {{ minPurchase | formatMoney(currencySign) }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="orderMode" class="m-4">
      <button
        type="button"
        class="btn btn-block p-2 continue-order-btn"
        @click="giftContinueOrder"
      >
        {{ $t("message.continueOrdering") }}
      </button>
    </div>

    <modal
      ref="privacyModal"
      v-if="showPrivacyModal"
      full-header
      @close="closePrivacyPolicyModal"
    >
      <template slot="body">
        <div class="container">
          <div class="d-flex justify-content-center">
            <h2 class="p-2 mt-2 privacy-header">
              {{ $t("message.termsAndConditions") }}
            </h2>
          </div>
          <p
            class="py-4 terms-and-conditions ios-scroll"
            v-html="currentStoreDoc.TermsAndConditions"
          ></p>
        </div>
      </template>
      <template slot="footer" class="bg-body">
        <div class="w-100" style="z-index: 2">
          <button
            class="privacy-btn pull-right"
            data-dismiss="modal"
            type="button"
            :style="buttonStyles"
            @click="closePrivacyPolicyModal()"
          >
            {{ $t("message.ok") }}
          </button>
        </div>
        <div class="privacy-footer" />
      </template>
    </modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import shares from "../../../sharedscripts/shop/shopping-cart/ShoppingCart";
import CartItem from "./GiftCartItem";
import { DateTime } from "luxon";
import CouponComponent from "../../shop/shopping-cart/CouponComponent";
import modal from "../../modal";
export default {
  name: "ShoppingCart",
  components: {
    CartItem,
    CouponComponent,
    modal,
  },
  props: {
    orderMode: {
      type: Boolean,
      default: false,
    },
    proccessing: {
      type: Boolean,
      default: false,
    },
    orderType: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      store: {},
      storeClosed: false,
      timerId: null,
      deliveryFee: 0,
      minPurchase: 0,
      showPrivacyModal: false,
    };
  },
  created() {
    this.store = this.currentStoreDoc;
  },
  computed: {
    ...shares.computed,
    ...mapGetters([
      "giftCartValue",
      "giftCartItems",
      "giftTotalPrice",
      "giftDiscount",
      "currentStoreDoc",
      "desktopStyles",
      "getGiftSurchargeAmount",
      "buttonStyles",
    ]),
    getStoreIsNotInOperationLang() {
      return this.$t("message.storeIsNotInOperation");
    },
    cartLength() {
      let sum = 0;
      this.giftCartItems.forEach((element) => {
        sum += parseInt(element.quantity);
      });
      return sum;
    },
    exceedMinPurchase() {
      return this.giftTotalPrice >= this.minPurchase;
    },
    refreshTime() {
      return DateTime.local().plus({ hours: 10 }).toUTC();
    },
    now() {
      return DateTime.local().toUTC();
    },
    orderDisbaled() {
      return (
        !this.exceedMinPurchase ||
        this.proccessing ||
        this.giftCartItems.length === 0
      );
    },
  },
  watch: {
    currentStoreDoc(newValue) {
      if (newValue) {
        this.giftComputeRules();
      }
    },
    orderType() {
      this.giftComputeRules();
    },
    giftTotalPrice() {
      this.giftComputeRules();
    },
  },
  beforeDestroy() {
    if (this.timerId) {
      clearInterval(this.timerId);
    }
  },
  methods: {
    ...shares.methods,
  },
};
</script>
